// extracted by mini-css-extract-plugin
export var askAiIcon = "_ow-k";
export var category = "_ow-a";
export var categoryHeader = "_ow-f";
export var container = "_ow-0";
export var group = "_ow-b";
export var groupItems = "_ow-g";
export var groupSeparator = "_ow-l";
export var highlight = "_ow-8";
export var loading = "_ow-1";
export var noResults = "_ow-3";
export var placeholder = "_ow-2";
export var resultContent = "_ow-5";
export var resultIcon = "_ow-d";
export var resultItem = "_ow-h";
export var resultMeta = "_ow-9";
export var resultSubtitle = "_ow-7";
export var resultSuffix = "_ow-j";
export var resultTitle = "_ow-6";
export var resultsList = "_ow-4";
export var searchGroup = "_ow-e";
export var selected = "_ow-i";
export var subgroup = "_ow-c";